import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { BsStar, BsStarFill, BsStarHalf } from 'react-icons/bs';

function SmallStarRating ({ rating }) {
    return (
      <Flex alignItems="center">
        {Array(5)
          .fill('')
          .map((_, i) => {
            const roundedRating = Math.round(rating * 2) / 2;
            if (roundedRating - i >= 1) {
              return (
                <BsStarFill
                  key={i}
                  style={{ marginLeft: '1' }}
                  color={i < rating ? 'teal.500' : 'gray.300'}
                />
              );
            }
            if (roundedRating - i === 0.5) {
              return <BsStarHalf key={i} style={{ marginLeft: '1' }} />;
            }
            return <BsStar key={i} style={{ marginLeft: '1' }} />;
          })}
          <Text pl="10px">{rating}.0</Text>
      </Flex>
    );
}

export default SmallStarRating;
